import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@mantine/core";
import { useCallback, useState } from "react";
import { AppDrawer } from "../../shared/AppDrawer";
import { Confirmation } from "../../shared/Confirmation";
import { OrganizationFormContent } from "./OrganizationFormContent";
export const OrganizationDrawer = ({ organizationId, options, opened, close }) => {
    const allowEdit = options?.allowEdit ?? false;
    // State
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    // Handlers
    const handleDirtyChange = useCallback((dirty) => {
        setIsDirty(dirty);
    }, []);
    const handleClose = () => {
        if (isDirty) {
            setConfirmOpen(true);
        }
        else {
            close();
        }
    };
    const handleConfirmLeave = async () => {
        setConfirmOpen(false);
        setIsDirty(false);
        close();
    };
    return (_jsxs(_Fragment, { children: [_jsx(AppDrawer, { scrollAreaComponent: ScrollArea.Autosize, withCloseButton: false, styles: {
                    content: {
                        padding: 0
                    }
                }, opened: opened, onClose: handleClose, stackId: "organization", children: _jsx(OrganizationFormContent, { organizationId: organizationId, allowEdit: allowEdit, active: opened, onSuccess: close, onDirtyChange: handleDirtyChange }) }), _jsx(Confirmation, { action: "leave", additionalText: "You have unsaved changes that won't be saved.", opened: confirmOpen, close: () => setConfirmOpen(false), handleAction: handleConfirmLeave })] }));
};
